// In-app navigation history for the panel's "Go Back" button.
// Tracks every hash page the user opens (Sidebar, links, buttons) in
// sessionStorage, so Back always returns to the previously opened panel page
// and never leaves the app / never depends on the browser's history stack.

const KEY = 'ops-nav-stack';
const MAX = 50;
const SKIP = ['operator-login', 'superadmin-login', 'vendor-login', 'client-login', 'client-reset-password'];

let goingBack = false;

const read = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY)) || []; } catch (e) { return []; }
};
const write = (stack) => {
  try { sessionStorage.setItem(KEY, JSON.stringify(stack.slice(-MAX))); } catch (e) {}
};
const currentHash = () => window.location.hash.replace('#', '');

const record = () => {
  const h = currentHash();
  if (!h || SKIP.includes(h.split('/')[0])) return;
  const stack = read();
  if (stack[stack.length - 1] !== h) {
    stack.push(h);
    write(stack);
  }
};

if (typeof window !== 'undefined' && !window.__opsNavHistoryInit) {
  window.__opsNavHistoryInit = true;
  record();
  window.addEventListener('hashchange', () => {
    if (goingBack) { goingBack = false; return; }
    record();
  });
}

export const canGoBack = () => read().length > 1;

// Go to the previously opened page. Calls fallback() if there is none.
export const goBack = (fallback) => {
  const stack = read();
  const cur = currentHash();
  if (stack.length && stack[stack.length - 1] === cur) stack.pop();
  // Drop duplicates of the current page sitting right below it
  while (stack.length && stack[stack.length - 1] === cur) stack.pop();
  const prev = stack[stack.length - 1];
  write(stack);
  if (prev) {
    goingBack = true;
    window.location.hash = prev; // App's hashchange listener renders the page
  } else if (fallback) {
    fallback();
  }
};
